module.exports = __webpack_public_path__ + "img/15.2b627a44.png";